<ng-template #cardTpl>
  <div class="sc-header">
    <img src="assets/img/logo.png" class="sc-logo" alt="Linguwa" />
    <div class="sc-brand">
      <span class="sc-brand-name">Linguwa</span>
      <span class="sc-brand-sub">KELİME ÖĞRENİMİ</span>
    </div>
  </div>

  <div class="sc-title-block">
    <div class="sc-eyebrow">4 FARKLI DİLDE</div>
    <div class="sc-title">Günün Kelimesi</div>
  </div>

  <div class="sc-langs">
    <div class="sc-lang-card" *ngFor="let lang of languages">
      <div class="sc-lang-head">
        <div class="sc-flag" [ngClass]="'flag-' + lang.code"></div>
        <span class="sc-lang-name">{{ lang.label }}</span>
      </div>
      <div class="sc-word-wrap">
        <div class="sc-word" [class.placeholder]="!wordFor(lang.code)">
          {{ wordFor(lang.code) || 'bugünün kelimesi…' }}
        </div>
        <div class="sc-underline"></div>
      </div>
    </div>
  </div>

  <div class="sc-footer">
    <span class="sc-handle">@linguwa.app</span>
    <span class="sc-tagline">her gün yeni kelime</span>
  </div>
</ng-template>

<div class="card">
  <div class="card-header">
    <h3 class="card-title">Sosyal Medya Kartı &mdash; Günün Kelimesi</h3>
  </div>
  <div class="card-body">

    <p class="text-muted">
      Bu kelimenin İngilizce, Almanca, İspanyolca ve Fransızca karşılıklarını içeren
      1080&times;1920 (Instagram Story) görseli oluşturup indirin.
    </p>

    <div class="d-flex flex-wrap align-items-center mb-3">
      <div class="btn-group mr-2 mb-2" role="group">
        <button *ngFor="let s of styles" type="button" class="btn btn-sm"
          [class.btn-primary]="selectedStyle === s.key"
          [class.btn-outline-primary]="selectedStyle !== s.key"
          (click)="selectedStyle = s.key">{{ s.name }}</button>
      </div>

      <button type="button" class="btn btn-secondary btn-sm mr-2 mb-2" (click)="loadTranslations()" [disabled]="loading">
        {{ loading ? 'Yükleniyor...' : 'Çevirileri Yenile' }}
      </button>

      <button type="button" class="btn btn-success btn-sm mb-2" (click)="download()" [disabled]="generating || !hasTranslations">
        {{ generating ? 'Oluşturuluyor...' : 'PNG Olarak İndir' }}
      </button>
    </div>

    <div class="sc-scale-frame">
      <div class="sc-card" [ngClass]="'theme-' + selectedStyle">
        <ng-container *ngTemplateOutlet="cardTpl"></ng-container>
      </div>
    </div>

    <!-- Tam çözünürlüklü (1080x1920), ekran dışına konumlandırılmış, html2canvas ile dışa aktarım kaynağı -->
    <div class="sc-export-host">
      <div class="sc-card" #exportCard [ngClass]="'theme-' + selectedStyle">
        <ng-container *ngTemplateOutlet="cardTpl"></ng-container>
      </div>
    </div>

  </div>
</div>
